import { API2_URL, VERIFICATION_MEDIA_REQUEST, VERIFICATION_MEDIA_SHOW, VERIFICATION_MEDIA_FAIL } from "../store/config";
import {newNotification} from "./notifications";
import _ from 'lodash';
import {sessionService} from "redux-react-session";

/*List Show*/
export const verificationMediaShow = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(verificationMediaRequest());
				return fetch(`${API2_URL}/proigualdad/verification-media?per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(verficationMediaData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(verificationMediaFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/*List Data*/
const verficationMediaData = (json) => {
	return {
		type:VERIFICATION_MEDIA_SHOW,
		isFetching:false,
		payload:json.data,
		timestamp:Date.now()
	}
};

/*Request*/
const verificationMediaRequest = () => {
	return {
		type:VERIFICATION_MEDIA_REQUEST,
		isFetching:true,
		timestamp:Date.now()
	}
};

/*Fail*/
const verificationMediaFail = (error) => {
	return {
		type:VERIFICATION_MEDIA_FAIL,
		isFetching:false,
		error:error,
		timestamp:Date.now()
	}
};


// WEBPACK FOOTER //
// ./src/actions/verification_media.js